import { ThemeProvider } from "@climatepartner/components/Theme";
import { PropsWithChildren, ReactElement } from "react";

import { themePalette } from "../../../../../shared/ui/theme-palette";
import { PageChrome } from "./page-chrome";

// The header/sidebar/slots props app-shell would pass a dashboard layout are intentionally ignored:
// this screen is chrome-only.
// themePalette is a partial ThemeOptions patch, not the full CP theme; AppShell normally applies the
// full theme via its default layout, but the custom-layout path bypasses that, so this layout must
// supply its own ThemeProvider.
export const FullPageInviteLayout = ({ children }: PropsWithChildren<unknown>): ReactElement => (
  <ThemeProvider theme={themePalette}>
    <PageChrome>{children}</PageChrome>
  </ThemeProvider>
);
